// extracted by mini-css-extract-plugin
export default {"container":"logistic-regression_container__UAFQa"};